import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { renderHeaderIconContainer } from '@/components/Chat/ChatSidebar/InboxSelector'
import { useGetInboxesWithCustom } from '@/api/chat'

import Icon from '../../../Icons'
import Avatar from '../../../../Avatar'
import SideBuildingSelector from '../../SideBuildingSelector'
import { getAssetLink } from '../../../../helpers/get-asset-link'
import { chatTypeToIconMap } from '../../helpers'

const InboxTab = ({
  userData,
  handleClose,
  selectBuilding,
  buildings,
  selectedBuilding,
  unreadConversationIds,
  handleOpenInbox,
}) => {
  const { t } = useTranslation(['chat'])
  const { getFilteredByRoleInboxes } = useGetInboxesWithCustom({
    buildingId: selectedBuilding?.id,
    chatCustom: selectedBuilding?.chatCustom,
  })
  const filteredInboxes = getFilteredByRoleInboxes(userData)
  const hasMoreThanOneOption = filteredInboxes.length > 1

  const handleOnChange = useCallback((e) => selectBuilding(e.target.value), [])

  const getNumberOfUnreadMessages = (inboxType) => {
    if (inboxType === 'ALL') {
      return unreadConversationIds.length
    }
    return unreadConversationIds.filter((conv) => conv.includes(`_${inboxType}`)).length || null
  }

  const allUnreadConvCounter = getNumberOfUnreadMessages('ALL')

  return (
    <div className="inbox-tab">
      <div className="tab-navbar">
        <Avatar size="big">
          <img
            src={getAssetLink({ path: 'chitown-avatar/avatar', file: userData.user.avatar })}
            alt=""
          />
        </Avatar>
        <div className="navi-button" onClick={handleClose}>
          <Icon icon="cross" />
        </div>
      </div>
      <div className="tab-body">
        <div className="space-row">
          <h1>{t('chat:widgetInboxTab.title')}</h1>
          <SideBuildingSelector
            showFullSelect
            selectedBuilding={selectedBuilding}
            buildings={buildings}
            onChange={handleOnChange}
          />
        </div>
        {hasMoreThanOneOption && (
          <div className="inbox-option" onClick={() => handleOpenInbox('ALL')}>
            <div className="option-content">
              {renderHeaderIconContainer(chatTypeToIconMap.ALL)}
              <span>{t('chat:widgetInboxTab.unifiedInbox')}</span>
            </div>
            {allUnreadConvCounter ? (
              <div className="unread-counter">{allUnreadConvCounter}</div>
            ) : null}
          </div>
        )}

        {filteredInboxes.map((inbox) => {
          const unreadConvCounter = getNumberOfUnreadMessages(inbox.type)
          return (
            <div key={inbox.id} className="inbox-option" onClick={() => handleOpenInbox(inbox)}>
              <div className="option-content">
                {renderHeaderIconContainer(chatTypeToIconMap[inbox.type])}
                <span>{inbox.name}</span>
              </div>
              {unreadConvCounter ? <div className="unread-counter">{unreadConvCounter}</div> : null}
            </div>
          )
        })}
        {userData.user.role !== 'Administrator' && (
          <div
            className="assigned-button"
            onClick={() => handleOpenInbox(filteredInboxes[0], 'assignedToYou')}
          >
            <div>
              <h2>{t('chat:widgetAssignedToMe.title')}</h2>
              <span>{t('chat:widgetAssignedToMe.viewAll')}</span>
            </div>
            <Icon icon="arrow" viewBox="0 2 16 16" fill="#B5B4B4" />
          </div>
        )}
      </div>
    </div>
  )
}

InboxTab.propTypes = {
  userData: PropTypes.object,
  handleClose: PropTypes.func,
  selectBuilding: PropTypes.func,
  buildings: PropTypes.array,
  selectedBuilding: PropTypes.object,
  unreadConversationIds: PropTypes.array,
  handleOpenInbox: PropTypes.func,
}

export default InboxTab
